import React, { useState, useEffect } from "react";
import axios from "axios";

import "./style.css";

export default function Certifications() {
  const [certificates, setcertificates] = useState([]);
  const [loading, setLoading] = useState(0);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND_URL + "/api/certificates")
      .then((res) => {
        //console.log(res.data);
        setcertificates(res.data);
        if (res.data.length > 0) {
          setLoading(1);
        }
      });
  }, []);

  return (
    <div>
      <div class="education group">
        <div
          class="heading"
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-duration="400"
        >
          <h2 class="text-center">Certifications</h2>
        </div>

        {loading == 0 ? (
          <center>
            <div
              class="spinner-border text-primary"
              role="status"
              style={{ marginBottom: "100px" }}
            >
              <span class="sr-only">Loading...</span>
            </div>
          </center>
        ) : (
          certificates.map((certificate) => {
            return (
              <a href={certificate.CredentialURL}>
                <div
                  class="item"
                  style={{ textAlign: "left" }}
                  data-aos="fade-up"
                  data-aos-delay="400"
                  data-aos-duration="500"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <h3>
                        <i class="fas fa-certificate"></i> &nbsp;
                        {certificate.Name}
                      </h3>
                      <p class="text-muted" style={{ fontWeight: "normal" }}>
                        {certificate.IssuingOrganization}
                      </p>
                    </div>
                    <div class="col-6">
                      <span class="period">
                        {" "}
                        {certificate.Date.substring(0, 7)}
                      </span>
                    </div>
                  </div>
                  <p class="text-muted">{certificate.CredentialID}</p>
                </div>
              </a>
            );
          })
        )}
      </div>
    </div>
  );
}
